export const climbTypes = ['Boulder', 'Sport', 'Trad']
